import { useInternalConversationService } from "@/presentation/deduction/internal-conversations/context/InternalConversationProvider";

export default function useInternalConversation() {
    return useInternalConversationService();
}
